import { render, staticRenderFns } from "./TestMenu.vue?vue&type=template&id=66f6dab2&scoped=true&"
import script from "./TestMenu.vue?vue&type=script&lang=js&"
export * from "./TestMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6dab2",
  null
  
)

export default component.exports